export const MenuDashboard = 'dashboard';
export const MenuSensorData = 'sensor-data';
export const MenuAnalysisData = 'analysis-data';
export const MenuQSReport = 'qs-report';
export const MenuGeneralSettings = 'general-settings';
export const MenuContactSupport = 'contact-support';
export const MenuSystemSettings = 'system-settings';
export const MenuAdminSettings = 'admin-settings';
